import React from 'react';
import styles from './GeneratingScreen.module.css';

interface GeneratingScreenProps {
  clientName: string;
}

export const GeneratingScreen: React.FC<GeneratingScreenProps> = ({ clientName }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.icon}>🤖</div>
        <div className={styles.spinner} />
        <h2 className={styles.title}>Generating Program</h2>
        <p className={styles.subtitle}>
          Our AI is creating a personalized training program for <strong>{clientName}</strong>
        </p>
        <div className={styles.steps}>
          <div className={styles.step}>
            <span className={styles.check}>✓</span>
            <span>Analyzing client profile</span>
          </div>
          <div className={styles.step}>
            <span className={styles.check}>✓</span>
            <span>Considering goals and limitations</span>
          </div>
          <div className={styles.step}>
            <span className={styles.dot}>●</span>
            <span>Building workout structure</span>
          </div>
          <div className={styles.step}>
            <span className={styles.pending}>○</span>
            <span>Optimizing exercise selection</span>
          </div>
        </div>
        <p className={styles.note}>This usually takes 10-20 seconds...</p>
      </div>
    </div>
  );
};
